function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "UX-+-UI-boilingWater",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "26-desktop-UI-boilingWater",
  transform: "translate(-189.000000, -1326.000000)",
  strokeWidth: 2
}, React.createElement("g", {
  id: "boiling-water-boilingWater",
  transform: "translate(190.000000, 1327.000000)"
}, React.createElement("circle", {
  id: "Oval-boilingWater",
  stroke: "#6EC18A",
  cx: 16.5,
  cy: 45.5,
  r: 2.5
}), React.createElement("circle", {
  id: "Oval-boilingWater",
  stroke: "#6EC18A",
  cx: 28,
  cy: 38,
  r: 2
}), React.createElement("circle", {
  id: "Oval-boilingWater",
  stroke: "#6EC18A",
  cx: 41.5,
  cy: 45.5,
  r: 3.5
}), React.createElement("path", {
  d: "M0,9 L58,9",
  id: "Path",
  stroke: "#3F5063",
  strokeLinecap: "square"
}), React.createElement("path", {
  d: "M23,9 L23,6 C23,2.6862915 25.6862915,0 29,0 C32.3137085,0 35,2.6862915 35,6 L35,9",
  id: "Path-boilingWater",
  stroke: "#3F5063"
}), React.createElement("path", {
  d: "M5,15 L5,51 C5,54.3137085 7.6862915,57 11,57 L47,57 C50.3137085,57 53,54.3137085 53,51 L53,15",
  id: "Path-boilingWater",
  stroke: "#3F5063",
  strokeLinecap: "square"
}), React.createElement("path", {
  d: "M6,28 L52,28",
  id: "Path-boilingWater",
  stroke: "#6EC18A"
}))));

var SvgBoilingWater = function SvgBoilingWater(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "60px",
    height: "62px",
    viewBox: "0 0 60 59",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBoilingWater, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/boilingWater.d951e963.svg";
export { ForwardRef as ReactComponent };